"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiquidationIntentStatus = exports.LiabilitySource = void 0;
/**
 * Liability sources from ARGOS
 * @TranslateToRust
 */
var LiabilitySource;
(function (LiabilitySource) {
    LiabilitySource["AvenTestLiability"] = "AvenTestLiability";
    LiabilitySource["CoreCard"] = "CoreCard";
})(LiabilitySource || (exports.LiabilitySource = LiabilitySource = {}));
/**
 * Status of a liquidation intent (from ARGOS).
 * @TranslateToPython
 * @TranslateToRust
 */
var LiquidationIntentStatus;
(function (LiquidationIntentStatus) {
    LiquidationIntentStatus["Pending"] = "pending";
    LiquidationIntentStatus["Submitted"] = "submitted";
    LiquidationIntentStatus["Filled"] = "filled";
    LiquidationIntentStatus["Failed"] = "failed";
    LiquidationIntentStatus["PaidOff"] = "paid_off";
})(LiquidationIntentStatus || (exports.LiquidationIntentStatus = LiquidationIntentStatus = {}));
